import { alpha, ListItem, ListItemButton, ListItemIcon, ListItemText, Theme } from "@mui/material";
import React from "react";

interface MenuListItemProps {
  open: boolean;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  primaryText: string;
  secondaryText?: string;
  onClick?: () => void;
  showText?: boolean;
  additionalSx?: any;
  href?: string;
  selected?: boolean;
}

export default function MenuListItem({
  open,
  icon,
  rightIcon,
  primaryText,
  secondaryText,
  onClick,
  showText = true,
  additionalSx,
  href,
  selected,
}: MenuListItemProps) {
  return (
    <ListItem disablePadding sx={{ display: "block", ...additionalSx }}>
      <ListItemButton
        {...(href ? { component: "a", href } : {})}
        selected={selected}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          if (href) {
            if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
            e.preventDefault();
          }
          onClick?.();
        }}
        sx={[
          {
            minHeight: 36,
            py: 0.5,
            display: "flex",
            alignItems: "center",
          },
          open
            ? {
                justifyContent: "initial",
                px: 2,
              }
            : {
                justifyContent: "center",
                px: 0,
              },
          {
            "&:hover": {
              backgroundColor: (theme: Theme) =>
                theme.palette.mode === "light" ? alpha(theme.palette.primary.main, 0.08) : alpha(theme.palette.primary.light, 0.12),
            },
            "&.Mui-selected": {
              backgroundColor: (theme: Theme) =>
                theme.palette.mode === "light" ? alpha(theme.palette.primary.main, 0.14) : alpha(theme.palette.primary.light, 0.2),
              color: "primary.main",
              "&:hover": {
                backgroundColor: (theme: Theme) =>
                  theme.palette.mode === "light" ? alpha(theme.palette.primary.main, 0.18) : alpha(theme.palette.primary.light, 0.26),
              },
            },
          },
        ]}
      >
        {icon && (
          <ListItemIcon
            sx={[
              {
                minWidth: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              open
                ? {
                    mr: 1.5,
                  }
                : {
                    mr: 0,
                  },
            ]}
          >
            {icon}
          </ListItemIcon>
        )}
        {showText && (
          <ListItemText
            primary={primaryText}
            secondary={secondaryText}
            sx={[
              open
                ? {
                    opacity: 1,
                    display: "block",
                  }
                : {
                    opacity: 0,
                    display: "none",
                  },
            ]}
          />
        )}
        {rightIcon && open && (
          <ListItemIcon
            sx={{
              minWidth: 0,
              justifyContent: "center",
              ml: "auto",
            }}
          >
            {rightIcon}
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}
